module.exports = "/images/vendor/flag-icon-css/flags/4x3/cm.svg?5799ad4c126b0a6b1a3f01599f862ad2";